/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trial_day_number: NonNullable<unknown> }} Onboarding_Paywall_Start_Triasl_Btn_CnaInputs */

const en_onboarding_paywall_start_triasl_btn_cna = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try ${i?.trial_day_number} Days for FREE`)
};

const ar_onboarding_paywall_start_triasl_btn_cna = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try ${i?.trial_day_number} Days for FREE`)
};

const de_onboarding_paywall_start_triasl_btn_cna = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try ${i?.trial_day_number} Days for FREE`)
};

const es_onboarding_paywall_start_triasl_btn_cna = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try ${i?.trial_day_number} Days for FREE`)
};

const fr_onboarding_paywall_start_triasl_btn_cna = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try ${i?.trial_day_number} Days for FREE`)
};

const it_onboarding_paywall_start_triasl_btn_cna = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try ${i?.trial_day_number} Days for FREE`)
};

const ja_onboarding_paywall_start_triasl_btn_cna = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try ${i?.trial_day_number} Days for FREE`)
};

const ko_onboarding_paywall_start_triasl_btn_cna = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try ${i?.trial_day_number} Days for FREE`)
};

const pt_br_onboarding_paywall_start_triasl_btn_cna = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try ${i?.trial_day_number} Days for FREE`)
};

const ru_onboarding_paywall_start_triasl_btn_cna = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try ${i?.trial_day_number} Days for FREE`)
};

const th_onboarding_paywall_start_triasl_btn_cna = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try ${i?.trial_day_number} Days for FREE`)
};

const tr_onboarding_paywall_start_triasl_btn_cna = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try ${i?.trial_day_number} Days for FREE`)
};

const zh_cn_onboarding_paywall_start_triasl_btn_cna = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免费体验 ${i?.trial_day_number} 天`)
};

const zh_tw_onboarding_paywall_start_triasl_btn_cna = /** @type {(inputs: Onboarding_Paywall_Start_Triasl_Btn_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免费体验 ${i?.trial_day_number} 天`)
};

/**
* | output |
* | --- |
* | "Try {trial_day_number} Days for FREE" |
*
* @param {Onboarding_Paywall_Start_Triasl_Btn_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_start_triasl_btn_cna = /** @type {((inputs: Onboarding_Paywall_Start_Triasl_Btn_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Start_Triasl_Btn_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_start_triasl_btn_cna(inputs)
	if (locale === "ar") return ar_onboarding_paywall_start_triasl_btn_cna(inputs)
	if (locale === "de") return de_onboarding_paywall_start_triasl_btn_cna(inputs)
	if (locale === "es") return es_onboarding_paywall_start_triasl_btn_cna(inputs)
	if (locale === "fr") return fr_onboarding_paywall_start_triasl_btn_cna(inputs)
	if (locale === "it") return it_onboarding_paywall_start_triasl_btn_cna(inputs)
	if (locale === "ja") return ja_onboarding_paywall_start_triasl_btn_cna(inputs)
	if (locale === "ko") return ko_onboarding_paywall_start_triasl_btn_cna(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_start_triasl_btn_cna(inputs)
	if (locale === "ru") return ru_onboarding_paywall_start_triasl_btn_cna(inputs)
	if (locale === "th") return th_onboarding_paywall_start_triasl_btn_cna(inputs)
	if (locale === "tr") return tr_onboarding_paywall_start_triasl_btn_cna(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_start_triasl_btn_cna(inputs)
	return zh_tw_onboarding_paywall_start_triasl_btn_cna(inputs)
});